import clsx from 'clsx';
import styles from './Logo.module.css';

export type LogoSize = 'sm' | 'md' | 'lg';

export interface LogoProps {
  size?: LogoSize;
  mono?: boolean;
  showWordmark?: boolean;
  className?: string;
}

export function Logo({
  size = 'md',
  mono = false,
  showWordmark = true,
  className,
}: LogoProps) {
  return (
    <span
      className={clsx(styles.logo, styles[size], mono && styles.mono, className)}
      aria-label="TwyMe"
    >
      <svg
        className={styles.mark}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M4 17C4 17 7.4 8.5 12 8.5C16.6 8.5 20 17 20 17"
          stroke="var(--partner)"
          strokeWidth="1.7"
          strokeLinecap="round"
        />
        <path
          d="M4 7C4 7 7.4 15.5 12 15.5C16.6 15.5 20 7 20 7"
          stroke="var(--accent)"
          strokeWidth="1.7"
          strokeLinecap="round"
        />
        <circle cx="12" cy="12" r="1.55" fill="var(--accent-tint-text)" />
      </svg>
      {showWordmark && <span className={styles.wordmark}>TwyMe</span>}
    </span>
  );
}
